module.exports = __webpack_public_path__ + "static/img/xiaohuangrenNew.00f375a9.png";